<template>
  <div class="tw-w-full tw-p-8 tw-h-full tw-flex tw-flex-col">
    <div class="mb-2 tw-text-2xl tw-font-bold">Quickly describe the job you need done</div>
    <textarea v-model="states.description" class="tw-flex-1 tw-rounded tw-p-5 tw-bg-light-4 tw-w-full" rows="8"></textarea>
  </div>
</template>
<script>
  import store from './submit-task-store'

  export default {
    beforeCreate() {
      this.store = store
    },
    data: v => ({
      states: store.states,
    }),
  }
</script>
